import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/toggletip/toggletip.js';
      import {ToggletipVariant} from '@oicl/openbridge-webcomponents/dist/components/toggletip/toggletip.js';

      export interface Props {
     variant?: ToggletipVariant;
     title?: string;
     description?: string | undefined;
     hasContent?: boolean;
     hasActions?: boolean;
     hasLeadingIcon?: boolean;
     hasTrailingIcon?: boolean;
     customWidth?: number | undefined;
     primaryButtonLabel?: string;
     secondaryButtonLabel?: string
   }

      
  
      export type {ToggletipVariant} from '@oicl/openbridge-webcomponents/dist/components/toggletip/toggletip.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcToggletip',
  props: {
    variant: {},
    title: {},
    description: {},
    hasContent: { type: Boolean },
    hasActions: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    hasTrailingIcon: { type: Boolean },
    customWidth: {},
    primaryButtonLabel: {},
    secondaryButtonLabel: {}
  },
  emits: ["primary-action", "secondary-action"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onPrimaryAction: (event: CustomEvent) => emit('primary-action', event as CustomEvent),
onSecondaryAction: (event: CustomEvent) => emit('secondary-action', event as CustomEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-toggletip',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})